import Container from '@/components/Container/Container'
import { ExplicitHead } from '@/components/DefaultHead/DefaultHead'
import Header from '@/components/Header/Header'
import Mail from '@/components/Mail/Mail'

const DESTINATION = 'edhrec@edhrec.com'

const ContactUs = () => (
  <Container small>
    <ExplicitHead
      title='Contact Us | EDHREC'
      description='Contact the EDHREC team'
      keywords='EDHREC,contact,email,message'
    />
    <Header>Contact Us</Header>
    <Mail
      description={
        <>
          <p>
            SCM Headquarters
            <div className='mt-1 ms-3'>
              8174 Lark Brown Rd
              <br />
              Unit 101
              <br />
              Elkridge, MD 21705
            </div>
          </p>
          <p>
            {'Use the form below, or email us at '}
            <a href={`mailto:${DESTINATION}`} rel='noreferrer' target='_blank'>
              {DESTINATION}
            </a>
            .
          </p>
        </>
      }
      destination={DESTINATION}
    />
  </Container>
)

export default ContactUs
